export default "__VITE_ASSET__B$b3Fhpf__"